import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2;

import { css } from "../../../lib/theming/Emotion";
export var menuHeaderSizeMixin = function menuHeaderSizeMixin(menuHeaderLegacyPaddingRight, menuHeaderPaddingX, menuHeaderFontSize, menuHeaderLineHeight, menuHeaderPaddingTop, menuHeaderPaddingBottom) {
  var legacyPaddingRight = parseFloat(menuHeaderLegacyPaddingRight);
  var paddingRight = legacyPaddingRight !== 0 ? parseFloat(menuHeaderPaddingX) + legacyPaddingRight + "px" : menuHeaderPaddingX;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    font-size: ", ";\n    line-height: ", ";\n    padding: ", " ", " ", " ", ";\n  "])), menuHeaderFontSize, menuHeaderLineHeight, menuHeaderPaddingTop, paddingRight, menuHeaderPaddingBottom, menuHeaderPaddingX);
};
export var withIconSizeMixin = function withIconSizeMixin(menuItemPaddingForIcon) {
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    padding-left: ", ";\n  "])), menuItemPaddingForIcon);
};